import { Component, ViewEncapsulation } from "@angular/core";

@Component({
  selector: 'app-loading-html',
  templateUrl: './empty.html',
  styleUrls: ['./loading-html.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoadingHtmlComponent {}
